import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableAudienceBuilder = Loadable({
  loader: function loader() {
    return import('../Audiences/AudienceBuilder.jsx');
  },
  loading: ComponentLoading
});
export default LoadableAudienceBuilder;